const formatNumber = (number: number): string => {
  if (number < 10000) return number.toLocaleString();
  if (number < 1000000) return `${(number / 1000).toFixed(1)}K`;
  if (number < 1000000000) return `${(number / 1000000).toFixed(1)}M`;
  if (number < 1000000000000) return `${(number / 1000000000).toFixed(1)}B`;
  return `${(number / 1e12).toFixed(1)}T`;
};

export default formatNumber;
